
export const DIFFERENT_CASH_ON_HAND_AMOUNT = 5;
export const INCORRECT_DIFFERENCE_AMOUNT = 6;